<div class="primer-modal">
  <div>
    <h3 class="primer-modal_heading">Start voice call</h3>
    <p class="primer-modal_subheading">
      Calls cost
      <span>{{ callPrice }}</span>
      tokens per minute
    </p>
  </div>
  <div class="primer-modal_info">
    <div class="primer-modal_info__items">
      <div class="info-item">
        <p class="info-item_title">You have</p>
        <div class="info-item_main">
          <stxt-svg-icon [iconConfig]="tokenIcon" class="info-item_svg"></stxt-svg-icon>
          <p class="info-item_text">
            {{ tokensBalance }} {{ availableMinutes === 1 ? 'token' : 'tokens' }}
          </p>
        </div>
      </div>
      <div class="info-item_divider"></div>
      <div class="info-item">
        <p class="info-item_title">Call for</p>
        <div class="info-item_main">
          <stxt-svg-icon [iconConfig]="clockIcon"></stxt-svg-icon>
          <p class="info-item_text">
            {{ availableMinutes }} {{ availableMinutes === 1 ? 'minute' : 'minutes' }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="primer-modal_footer">
    <stxt-button
      [buttonConfig]="primaryButton"
      (click)="buttonClick(primaryButton.text)"
      (keydown.enter)="buttonClick(primaryButton.text)"
    >
      <div class="primer-modal_button__content">
        <stxt-svg-icon
          *ngIf="availableMinutes > 0"
          [iconConfig]="callIcon"
          class="primer-modal_button__icon"
        ></stxt-svg-icon>
        <p>{{ primaryButton.text }}</p>
      </div>
    </stxt-button>
    <stxt-button
      [buttonConfig]="secondaryButton"
      (click)="buttonClick(secondaryButton.text)"
      (keydown.enter)="buttonClick(secondaryButton.text)"
      class="primer-modal_secondary-button"
    >
      {{ secondaryButton.text }}
    </stxt-button>
    <p
      (click)="buttonClick(footerText)"
      (keydown.enter)="buttonClick(footerText)"
      tabindex="0"
      class="primer-modal_footer__text"
    >
      {{ footerText }}
    </p>
  </div>
</div>
